// Utility functions for consistent lead handling across components

export const getStatusColor = (status) => {
  switch (status) {
    case 'Closed Won': return 'bg-green-100 text-green-800';
    case 'Closed Lost': return 'bg-red-100 text-red-800';
    case 'Cold Lead': return 'bg-gray-100 text-gray-800';
    case 'Prospecting': return 'bg-blue-100 text-blue-800';
    case 'Qualified': return 'bg-yellow-100 text-yellow-800';
    case 'Demo Scheduled / Done': return 'bg-purple-100 text-purple-800';
    case 'Evaluation / Pilot': return 'bg-indigo-100 text-indigo-800';
    case 'Decision': return 'bg-orange-100 text-orange-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

export const formatStatusCounts = (statusCountsArray) => {
  const statusCounts = {};
  if (statusCountsArray && Array.isArray(statusCountsArray)) {
    statusCountsArray.forEach(item => {
      if (item && item._id) {
        statusCounts[item._id] = item.count || 0;
      }
    });
  }
  return statusCounts;
};

export const calculateSuccessRate = (statusCounts, totalLeads) => {
  if (totalLeads === 0) return 0;
  const wonLeads = statusCounts['Closed Won'] || 0;
  return Math.round((wonLeads / totalLeads) * 100);
};

export const LeadStatusOptions = [
  { name: 'Cold Lead', value: 'Cold Lead' },
  { name: 'Prospecting', value: 'Prospecting' },
  { name: 'Qualified', value: 'Qualified' },
  { name: 'Demo Scheduled / Done', value: 'Demo Scheduled / Done' },
  { name: 'Evaluation / Pilot', value: 'Evaluation / Pilot' },
  { name: 'Decision', value: 'Decision' },
  { name: 'Closed Won', value: 'Closed Won' },
  { name: 'Closed Lost', value: 'Closed Lost' },
];